<script setup>
import DpButton from "./DpButton";
import DpExpand from "./DpExpand";
import DpIcon from "./DpIcon";
import { isEmpty } from 'lodash';
import {ref} from 'vue';

defineProps({
  headline: {type: String},
  description: {type: String},
  primaryButton: {type: Object},
  secondaryButton: {type: Object},
  dismissed: {type: Boolean, default: false},
  closable: {type: Boolean, default: true}
})
const activateDefaultSlot = ref(false);
</script>
<script>
export default {
    name: "DpReminder",
  }
</script>

<template>
  <div class="dp-reminder" v-if="!dismissed">
    <div v-if="closable" class="dp-reminder__close-button">
      <a v-on:click="dismissed=true">
        <DpIcon icon="close" :size="32" color="#909399" float="none"/>
      </a>
    </div>
    <DpExpand>
      <div v-show="activateDefaultSlot">
        <slot></slot>
      </div>
    </DpExpand>
    <DpExpand>
      <div v-show="!activateDefaultSlot">
        <div class="dp-reminder__phrases text-align-center">
          <slot name="phrases">
            <h3 v-if="headline">{{headline}}</h3>
            <p v-if="description">{{description}}</p>
          </slot>
        </div>
        <slot name="extraContent"></slot>
        <div v-if="!isEmpty(primaryButton) || !isEmpty(secondaryButton)" class="dp-reminder__buttons dp-flex justify-content__space-around">
          <DpButton v-if="!isEmpty(secondaryButton)" size="large" purpose="secondaryAction" class="dp-reminder__buttons"
                     @click="secondaryButton.action()">
            {{secondaryButton.label}}
          </DpButton>
          <DpButton v-if="!isEmpty(primaryButton)" size="large" purpose="primaryAction" class="dp-reminder__buttons"
                     @click="(primaryButton.action)? primaryButton.action() : activateDefaultSlot = true">
            {{primaryButton.label}}
          </DpButton>
        </div>
      </div>
    </DpExpand>
  </div>
</template>

<style lang="scss">
  .dp-reminder {
    position: relative;
    padding: 1em;
    background-color: var(--use-theme__background-color);
    border: 2px solid var(--use-theme__ui-gradient-1);
    border-radius: 8px;
    box-shadow: 0 5px 20px var(--use-theme__ui-gradient-1);
    overflow: hidden;
    margin: 1rem auto;

    .dp-reminder__buttons {
      margin-top: 1em;
      display: block;
    }

    .dp-reminder__close-button {
      position: absolute;
      top: 1rem;
      inset-block-start: 1rem;
      right: .5rem;
      inset-inline-end: .5rem;

      a,
      a:active,
      a:hover,
      a:focus {
        border-bottom: 0;
      }
    }
  }
</style>

<i18n>
  {
  "en-US": {
  }
  }
</i18n>
